import axios, { isAxiosError } from 'axios'

import { setTokenCallback } from './internal/tokenCallback'

export const gozokiApi = axios.create({
  timeout: 120_000,
  headers: {
    // Default header
    'Content-Type': 'application/json',
  },
})

export const gozokiApiWithAuth = axios.create({
  timeout: 120_000,
  headers: {
    // Default header
    'Content-Type': 'application/json',
  },
})

// ********************************************************* //
//                  INITIALIZER METHODS                      //
// ********************************************************* //

export const setApiUrl = (url: string) => {
  gozokiApi.defaults.baseURL = url
  gozokiApiWithAuth.defaults.baseURL = url
}

export const attachTokenCallback = (tokenCallback: () => Promise<string | null>) => {
  setTokenCallback(tokenCallback)

  // Attach token callback to api requests
  gozokiApiWithAuth.interceptors.request.use(
    async (config) => {
      const token = await tokenCallback()

      config.headers.Authorization = `Bearer ${token}`
      return config
    },
    (error) => Promise.reject(error),
  )
}

export const attachRedirectionOnUnauthorized = (redirectCallback: () => void) => {
  gozokiApiWithAuth.interceptors.response.use(
    (response) => response,
    (err) => {
      // Disconnect user if 401
      if (isAxiosError(err) && err?.response?.status === 401) {
        redirectCallback()
      }

      return Promise.reject(err)
    },
  )
}
